import { render } from "./App.vue?vue&type=template&id=3249abe2&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3249abe2&lang=less&scoped=true"

import exportComponent from "C:\\project\\digirebar\\famous-build-en\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3249abe2"]])

export default __exports__